export default __webpack_public_path__ + "static/media/Arabia logo-01.a5eff6af.png";